var _polygon, _polygon2, _polygon3, _polyline, _polyline2, _line, _line2, _polyline3, _line3, _polyline4, _line4, _polyline5, _circle, _circle2, _polyline6, _circle3, _circle4, _polyline7, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4999,
    y1: 14.5,
    x2: 31.4999,
    y2: 28.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDE6EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#C6E2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5419,
    style: {
      stopColor: "#B3D8E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9212,
    style: {
      stopColor: "#93C7D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CC3D2"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "38.5,21.5 24.5,13.5 10.5,21.5 24.5,29.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9999,
    y1: 24,
    x2: 26.9999,
    y2: 43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD7E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1588,
    style: {
      stopColor: "#A4D0DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7059,
    style: {
      stopColor: "#80BCCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73B4C8"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_2_)",
    points: "10.5,21.5 10.5,37.5 24.5,45.5 24.5,29.5 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3C91AF",
    points: "24.5,29.5 24.5,45.5 38.5,37.5 38.5,21.5 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    points: "10.5,21.5 24.5,29.5 38.5,21.5 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    points: "10.5,29.5 24.5,37.5 38.5,29.5 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#3C91AF",
    stroke: "#147391",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 24.5,
    y1: 29.5,
    x2: 24.5,
    y2: 45.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10,
    y1: 8,
    x2: 10,
    y2: 17
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "6,13 10,17 14,13 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39,
    y1: 8,
    x2: 39,
    y2: 17
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "35,13 39,17 43,13 "
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 9
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "20,5 24,9 28,5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 23,
    y1: 29.5,
    x2: 26,
    y2: 29.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_3_)",
    stroke: "#464646",
    cx: 24.5,
    cy: 29.5,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 24.5,
    cy: 37.5,
    r: 1.5
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    points: "31.5,17.5 17.5,25.5 17.5,41.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 16,
    y1: 25.5,
    x2: 19,
    y2: 25.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_4_)",
    stroke: "#464646",
    cx: 17.5,
    cy: 25.5,
    r: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 17.5,
    cy: 33.5,
    r: 1.5
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    points: "17.5,17.5 31.5,25.5 31.5,41.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#464646",
    strokeMiterlimit: 10,
    d: "M24.5,13.5l-14,8v16l14,8l14-8v-16L24.5,13.5z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 10.5,
    cy: 21.5,
    r: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 10.5,
    cy: 29.5,
    r: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 10.5,
    cy: 37.5,
    r: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 17.5,
    cy: 17.5,
    r: 1.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 24.5,
    cy: 21.5,
    r: 1.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 38.5,
    cy: 21.5,
    r: 1.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 31.5,
    cy: 17.5,
    r: 1.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 24.5,
    cy: 13.5,
    r: 1.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 24.5,
    cy: 45.5,
    r: 1.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 31.5,
    cy: 25.5,
    r: 1.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 31.5,
    cy: 33.5,
    r: 1.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 31.5,
    cy: 41.5,
    r: 1.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 38.5,
    cy: 29.5,
    r: 1.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 38.5,
    cy: 37.5,
    r: 1.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 17.5,
    cy: 41.5,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisItem);
export default __webpack_public_path__ + "static/media/AnalysisItem.2b761457e5a78e810c208fe42ed40ec0.svg";
export { ForwardRef as ReactComponent };